import type { AuthLoginDesafioOtpResponseDto, AuthLoginResponseDto } from "../../dtos/authenticator.dto";

// ------------------------------- FUNCTIONS -------------------------------
export function validarSessaoLoginUnificado(dados: AuthLoginResponseDto): void {
	if (
		typeof dados?.token !== "string" ||
		!dados.token.trim() ||
		!Number.isSafeInteger(dados.grupo?.id) ||
		dados.grupo.id < 0 ||
		typeof dados.grupo.nome !== "string"
	)
		throw new Error("Não foi possível concluir o login: resposta de sessão inválida.");
}

export function validarDesafioLoginUnificado(dados: AuthLoginDesafioOtpResponseDto): void {
	if (
		typeof dados?.desafio_otp !== "string" ||
		!dados.desafio_otp.trim() ||
		!Number.isFinite(dados.expiracao_segundos) ||
		dados.expiracao_segundos < 0
	)
		throw new Error("Não foi possível iniciar a verificação em duas etapas.");
}
